import { render, staticRenderFns } from "./SearchArchitectureBar.vue?vue&type=template&id=6f86830a&scoped=true"
import script from "./SearchArchitectureBar.vue?vue&type=script&lang=js"
export * from "./SearchArchitectureBar.vue?vue&type=script&lang=js"
import style0 from "./SearchArchitectureBar.vue?vue&type=style&index=0&id=6f86830a&prod&scoped=true&lang=css"
import style1 from "./SearchArchitectureBar.vue?vue&type=style&index=1&id=6f86830a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86830a",
  null
  
)

export default component.exports